/**
 * O painel esquerdo das telas de login e criar conta.
 *
 * As formas abstratas são posicionadas em absoluto exatamente como no
 * handoff. Ficam com `aria-hidden` porque são decoração: leitor de tela não
 * tem nada a ganhar anunciando seis círculos.
 *
 * Some abaixo de 1024px — em tablet de balcão a coluna de conteúdo é que
 * importa, e o painel roubaria metade da largura útil.
 */
import type { ReactNode } from 'react'

import { Lockup } from './Marca'

export function PainelLateral({
  titulo,
  subtitulo,
  children,
}: {
  titulo: string
  subtitulo: string
  children?: ReactNode
}) {
  return (
    <div className="relative hidden flex-col justify-between overflow-hidden border-r border-divisoria bg-superficie px-14 pt-11 pb-10 lg:flex">
      <FormasAbstratas />

      <div className="relative">
        <Lockup />
      </div>

      <div className="relative max-w-[520px]">
        <h1 className="mb-[18px] font-titulo text-[34px] leading-[1.22] font-bold text-pretty text-titulo">
          {titulo}
        </h1>
        <p className="mb-[30px] max-w-[360px] text-[15px] leading-[1.65] text-pretty text-texto-suave">
          {subtitulo}
        </p>
        {children}
      </div>

      <div className="relative text-[12.5px] text-texto-fraco">© 2026 Lumma Software</div>
    </div>
  )
}

/** Lista de benefícios da tela de login, com o check da marca. */
export function ListaDeBeneficios({ itens }: { itens: string[] }) {
  return (
    <ul className="flex flex-col gap-[14px]">
      {itens.map((item) => (
        <li key={item} className="flex items-center gap-3">
          <span aria-hidden className="text-[15px] font-bold text-marca">
            ✓
          </span>
          <span className="text-[15px] text-texto">{item}</span>
        </li>
      ))}
    </ul>
  )
}

function FormasAbstratas() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute -top-[150px] -right-[170px] h-[460px] w-[460px] rounded-full border border-borda" />
      <div className="absolute -top-20 -right-[100px] h-[300px] w-[300px] rounded-full bg-marca-fundo" />
      <div className="absolute right-16 bottom-[120px] h-[132px] w-[132px] rotate-[18deg] rounded-[34px] bg-marca-fundo-2" />
      <div className="absolute right-[170px] bottom-[210px] h-14 w-14 rounded-full border-2 border-marca-suave" />
      <div className="absolute right-[210px] bottom-16 h-[10px] w-[10px] rounded-full bg-marca" />
      <div
        className="absolute top-[44%] right-[34px] h-[150px] w-px"
        style={{
          background: 'linear-gradient(to bottom, rgba(37,99,235,0.35), rgba(37,99,235,0))',
        }}
      />
    </div>
  )
}
